export const getAddTooltipContent = ({ isAllLicensesAdded }: { isAllLicensesAdded: boolean }) =>
  isAllLicensesAdded
    ? 'All licenses are linked to bank accounts'
    : 'Please complete all required fields to add bank account.'
